import { saveStartupIdeaWithoutPayment } from "../../utils/api";
import toast from "react-hot-toast";
import { CheckCircle, ChevronRight,Building2, Calendar, Mail, Phone, Rocket, X,User  } from "lucide-react";
import React,{useState,useEffect}  from "react";
const stepsTop = [
  {
    title: "Step 1",
    subtitle: "Book a Call",
    desc: "Tell us your idea or business need",
  },
  {
    title: "Step 2",
    subtitle: "Discovery Session",
    desc: "We analyse your vision, challenges, and goals.",
  },
  {
    title: "Step 3",
    subtitle: "Custom Strategy Plan",
    desc: "TACTOS designs a tailored path for you.",
  },
];

const stepsBottom = [
  {
    title: "Step 4",
    subtitle: "Execution Support",
    desc: "We help implement the plan step-by-step.",
  },
  {
    title: "Step 5",
    subtitle: "Long-term Guidance",
    desc: "Regular reviews, growth support, and investor readiness",
  },
];

const BussinessPage = () => {
    const [isModalOpen, setIsModalOpen] = useState(false)
 const [formData, setFormData] = useState({
founderName: "",
  founderEmail: "",
  founderPhone: "",
  startupName: "",
  cityAndState: "",
  founderRole: "",
  cohortApplyingFor: "",

  aboutStartup: "",
  startupStage: "",
  problemSolving: "",
  whyProblemMattersNow: "",

  fundraisingIntent: "",
  fundsRaisedAmount: "",

  bootcampExpectation: "",
  onsiteCommitment: "",

  pitchDeckLink: "",
  founderLinkedIn: "",
  companyLinkedIn: "",
  companyWebsite: "",

  declarationAccepted: false,
    programType:"business-consultation"
})
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [currentStep, setCurrentStep] = useState(1)

  const [processing, setProcessing] = useState(false);
 


  const handleSubmit = async () => {
   
    setProcessing(true);

    try {
      // 1. Validate inputs
      if (!formData.name || !formData.phone || !formData.email) {
        toast.error("Please fill all required fields");
        setProcessing(false);
        return;
      }


      const responce=await saveStartupIdeaWithoutPayment(formData)

      setIsSubmitting(true)
      setIsModalOpen(false)
      toast.success(responce.message)
setFormData({...formData,founderName: "",
  founderEmail: "",
  founderPhone: "",
  startupName: "",
  cityAndState: "",
  founderRole: "",
  cohortApplyingFor: "",

  aboutStartup: "",
  startupStage: "",
  problemSolving: "",
  whyProblemMattersNow: "",

  fundraisingIntent: "",
  fundsRaisedAmount: "",

  bootcampExpectation: "",
  onsiteCommitment: "",

  pitchDeckLink: "",
  founderLinkedIn: "",
  companyLinkedIn: "",
  companyWebsite: "",

  declarationAccepted: false,
    programType:"business-consultation"})
    setCurrentStep(1)
    } catch (error) {
      console.error("Something went wrong:", error);
      toast.error(error.message || "Something went wrong:");
    } finally {
        setIsSubmitting(false)
      setProcessing(false);
    }
  };
  return (
    <>
       <section className="py-10 px-6 md:px-20">
              <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
      
                {/* LEFT CONTENT */}
                <div className="order-2 md:order-1">
                  <h2 className="text-4xl font-extrabold text-gray-900 mb-6">
                    What is the TACTOS <br /><span className="text-[#fd3e3d]">Business Consultation?</span>
                  </h2>
      
                  <p className="text-gray-700 text-lg max-w-xl leading-relaxed mb-10 text-justify">
                  TACTOS provides end-to-end business consulting for startups, SMEs,
            institutions, and emerging founders. From idea validation to
            strategy execution, we act as your strategic partner.
                  </p>
                  <div className="text-center">
                    <button
                      onClick={() => setIsModalOpen(true)}
                      className="inline-flex items-center gap-3 bg-[#fd3e3d] hover:bg-[#e63635] text-white font-semibold py-4 px-10 rounded-xl shadow-lg hover:shadow-xl transition w-full justify-center"
                    >
                      Apply Now
                      <ChevronRight className="w-5 h-5" />
                    </button>
                  </div>
      
      
                </div>
      
                {/* RIGHT IMAGE */}
                <div className="order-1 md:order-2 flex justify-center md:justify-end">
                  <img
                    src="/bussinessnewpage.jpg"
                    alt="Bootcamp"
                    className="rounded-xl w-full max-w-md"
                  />
                </div>
      
              </div>
            </section>
      <section className="py-10 px-6 md:px-16">
        <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-14">
          HOW IT <span className="text-[#fd3e3d]"> WORKS?</span>
        </h2>

        {/* TOP 3 STEPS */}
        <div className="flex flex-col md:flex-row justify-center gap-8 mb-10">
          {stepsTop.map((item, i) => (
            <div
              key={i}
              className="relative w-full md:w-[30%] border p-6 rounded-xl bg-white shadow-sm"
            >
              <h3 className="text-xl font-bold text-center">{item.title}</h3>
              <p className="font-semibold text-center my-1">{item.subtitle}</p>
              <p className="text-gray-800 text-center text-sm">{item.desc}</p>

              {/* Arrow */}
              <div
                className="hidden md:block absolute right-[-30px] top-1/2 -translate-y-1/2
                  w-0 h-0 border-t-[30px] border-b-[30px] border-l-[30px]
                  border-transparent border-l-[#fd3e3d] drop-shadow"
              ></div>
            </div>
          ))}
        </div>

        {/* BOTTOM 2 STEPS */}
        <div className="flex flex-col md:flex-row justify-center gap-6 mb-16">
          {stepsBottom.map((item, i,arr) => (
            <div
              key={i}
              className="relative   w-full md:w-[32%] border p-6 rounded-xl bg-white shadow-sm"
            >
              <h3 className="text-xl font-bold text-center">{item.title}</h3>
              <p className="font-semibold text-center my-1">{item.subtitle}</p>
              <p className="text-gray-800 text-center text-sm">{item.desc}</p>

              {/* Arrow */}
              {i !== arr.length - 1 && (
        <div
          className="hidden md:block absolute right-[-25px] top-1/2 -translate-y-1/2
          w-0 h-0 border-t-[25px] border-b-[25px] border-l-[25px] border-transparent
          border-l-[#fd3e3d] drop-shadow-md"
        ></div>
      )}
            </div>
          ))}
        </div>

        {/* APPLY NOW */}
        {/* <div className="flex justify-center mb-6">
          <button onClick={()=>setIsModalOpen(true)} className="bg-[#fd3e3d] text-white text-lg font-bold px-10 py-3 rounded-full shadow-md hover:bg-[#e63635] transition">
            APPLY NOW
          </button>
        </div> */}

        <p className="text-center text-xl font-medium text-gray-800 mt-4">
          Get Tactos as your Business / Startup Consultant Now
        </p>
      </section>

      <section className="py-10 ">
        <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-5">
         WHAT YOU <span className="text-[#fd3e3d]"> WILL GET ?</span>
        </h2>

        <div className="container mx-auto max-w-6xl px-4 md:px-8 grid md:grid-cols-3 gap-10">

          {[
  {
    title: "Deep-Dive Discovery & Diagnosis",
    description:
      "We begin by understanding your business from the inside out - goals, bottlenecks, operations, customer experience, cash flow, and team structure. We identify your biggest growth levers and hidden challenges, then design practical solutions that lead to a validated startup idea and a clearly defined target customer.",
  },
  {
    title: "Strategic Blueprinting",
    description:
      "Once the diagnosis is complete, we create a clear business strategy covering market positioning, product direction, expansion roadmap, revenue models, and competitive advantage. Our consulting team builds a tailored blueprint that explains what to do, why it matters, and how to execute it effectively.",
  },
  {
    title: "Operational System Design",
    description:
      "We convert strategy into real operational systems including workflows, SOPs, team responsibilities, KPIs, customer journey maps, and accountability frameworks. This ensures your business runs smoothly, predictably, and efficiently by replacing chaos with clarity.",
  },
  {
    title: "High-Impact Implementation Support",
    description:
      "We don’t just advise - we work alongside your leadership team to execute every strategic milestone. With TACTOS as your consulting partner, implementation becomes faster, structured, measurable, and outcome-driven.",
  },
  {
    title: "CXO-Level Guidance (TACTOS Mentorship)",
    description:
      "You gain direct access to top-level mentors who act as your CXOs, steering the company with real-time decisions, strategic insights, and hands-on execution support to keep your business on the right growth path.",
  },
  {
    title: "Data, Metrics & Performance Tracking",
    description:
      "Every decision is backed by dashboards, metrics, and measurable performance indicators. This creates predictable progress, faster decision-making, and continuous optimization by refining strategies, fixing bottlenecks, and unlocking new growth opportunities.",
  },
].map((data,index, i) => (
            <div 
              key={i}
              className="border rounded-xl p-6 shadow-sm hover:shadow-lg transition"
            >
              <h4 className="font-bold text-lg mb-3">{data.title}</h4>
              <p className="text-gray-600 space-y-2 text-sm leading-relaxed">{data.description}</p>

              {/* <ul className="text-gray-600 space-y-2 text-sm leading-relaxed">
                {bullets.map((b, index) => (
                  <li key={index}>{b}</li>
                ))}
              </ul> */}

            </div>
          ))}

        </div>
         <div className="flex justify-center mb-3 mt-10">
          <button onClick={()=>setIsModalOpen(true)} className="bg-[#fd3e3d] text-white text-lg font-bold px-10 py-3 rounded-full shadow-md hover:bg-[#e63635] transition">
            APPLY NOW
          </button>
        </div>
      </section>
      
    {isModalOpen && (
  <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
    <div
      className="absolute inset-0 bg-black/60 backdrop-blur-sm"
      onClick={() => setIsModalOpen(false)}
    />

    <div className="relative w-full max-w-xl max-h-[98vh] rounded-2xl overflow-hidden shadow-2xl bg-white">

      {/* HEADER */}
      <div className="bg-black p-6 text-center relative">
        <button
          onClick={() => setIsModalOpen(false)}
          className="absolute top-4 right-4 text-white/80 hover:text-white"
        >
          <X className="w-6 h-6" />
        </button>

        <div className="flex justify-center mb-3">
          <div className="bg-[#fd3e3d] p-3 rounded-full">
            <Calendar className="w-8 h-8 text-white" />
          </div>
        </div>

        <h3 className="text-white text-2xl font-bold">
          TACTOS Business Consultation Application Form
        </h3>
      </div>

      {/* STEPPER */}
      <div className="px-6 py-6">
        <div className="flex items-center justify-between relative">
          <div className="absolute top-1/2 left-0 w-full h-[2px] bg-gray-300 -translate-y-1/2" />
          <div
            className="absolute top-1/2 left-0 h-[2px] bg-[#fd3e3d] -translate-y-1/2 transition-all duration-500"
            style={{ width: `${((currentStep - 1) / 3) * 100}%` }}
          />

          {[1, 2, 3, 4].map(step => (
            <div key={step} className="relative z-10">
              <div
                className={`w-9 h-9 rounded-full flex items-center justify-center text-sm font-bold
                  ${currentStep >= step ? "bg-[#fd3e3d] text-white scale-110" : "bg-gray-200 text-gray-500"}
                `}
              >
                {step}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* FORM */}
      <form className="p-6 space-y-5 overflow-y-auto max-h-[60vh]">

        {/* STEP 1 – BASIC INFORMATION */}
        {currentStep === 1 && (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

    <div>
      <label className="text-sm text-black/70">Full Name</label>
      <input
        value={formData.founderName}
        onChange={e => setFormData({ ...formData, founderName: e.target.value })}
        placeholder="Full Name"
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

    <div>
      <label className="text-sm text-black/70">Email</label>
      <input
        value={formData.founderEmail}
        onChange={e => setFormData({ ...formData, founderEmail: e.target.value })}
        placeholder="Email"
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

    <div>
      <label className="text-sm text-black/70">Phone Number</label>
      <input
        value={formData.founderPhone}
        onChange={e => setFormData({ ...formData, founderPhone: e.target.value })}
        placeholder="Phone Number"
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

    <div>
      <label className="text-sm text-black/70">Company / Startup Name</label>
      <input
        value={formData.startupName}
        onChange={e => setFormData({ ...formData, startupName: e.target.value })}
        placeholder="Company / Startup Name"
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

    <div>
      <label className="text-sm text-black/70">City & Country</label>
      <input
        value={formData.cityCountry}
        onChange={e => setFormData({ ...formData, cityCountry: e.target.value })}
        placeholder="City & Country"
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

    <div>
      <label className="text-sm text-black/70">
        Website / Social Profile (if any)
      </label>
      <input
        value={formData.websiteOrSocial}
        onChange={e => setFormData({ ...formData, websiteOrSocial: e.target.value })}
        placeholder="Website / Social Profile (if any)"
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

  </div>
)}


        {/* STEP 2 – BUSINESS SNAPSHOT */}
      {currentStep === 2 && (
  <div className="grid grid-cols-1 gap-4">

    <div>
      <label className="text-sm text-black/70">
        What stage is your business in?
      </label>
      <select
        value={formData.businessStage}
        onChange={e => setFormData({ ...formData, businessStage: e.target.value })}
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      >
        <option value="">Select stage</option>
        <option>Early Revenue</option>
        <option>Scaling</option>
        <option>Established</option>
      </select>
    </div>

    <div>
      <label className="text-sm text-black/70">
        Briefly describe your business in one sentence
      </label>
      <textarea
        value={formData.businessDescription}
        onChange={e =>
          setFormData({ ...formData, businessDescription: e.target.value })
        }
        placeholder="Briefly describe your business in one sentence"
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

    <div>
      <label className="text-sm text-black/70">
        What primary challenge are you facing right now?
      </label>
      <textarea
        value={formData.primaryChallenge}
        onChange={e =>
          setFormData({ ...formData, primaryChallenge: e.target.value })
        }
        placeholder="What primary challenge are you facing right now?"
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

    <div>
      <label className="text-sm text-black/70">
        What outcome do you want from TACTOS consultation?
      </label>
      <textarea
        value={formData.expectedOutcome}
        onChange={e =>
          setFormData({ ...formData, expectedOutcome: e.target.value })
        }
        placeholder="What outcome do you want from TACTOS consultation?"
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

    <div>
      <label className="text-sm text-black/70">
        Current monthly revenue (optional)
      </label>
      <input
        value={formData.monthlyRevenue}
        onChange={e =>
          setFormData({ ...formData, monthlyRevenue: e.target.value })
        }
        placeholder="Current monthly revenue (optional)"
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

  </div>
)}

        {/* STEP 3 – READINESS & SCHEDULING */}
       {currentStep === 3 && (
  <div className="grid grid-cols-1 gap-4">

    <div>
      <label className="text-sm text-black/70">
        Are you ready to execute strategic changes in the next 90 days?
      </label>
      <select
        value={formData.readyForExecution}
        onChange={e =>
          setFormData({ ...formData, readyForExecution: e.target.value })
        }
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      >
        <option value="">Yes / No</option>
        <option>Yes</option>
        <option>No</option>
      </select>
    </div>

    <div>
      <label className="text-sm text-black/70">
        Preferred date for a discovery call
      </label>
      <input
        type="date"
        value={formData.preferredCallDate}
        onChange={e =>
          setFormData({ ...formData, preferredCallDate: e.target.value })
        }
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

    <div>
      <label className="text-sm text-black/70">Website</label>
      <input
        value={formData.website}
        onChange={e => setFormData({ ...formData, website: e.target.value })}
        placeholder="Website"
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

    <div>
      <label className="text-sm text-black/70">LinkedIn</label>
      <input
        value={formData.linkedIn}
        onChange={e => setFormData({ ...formData, linkedIn: e.target.value })}
        placeholder="LinkedIn"
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

  </div>
)}


        {/* STEP 4 – DECLARATION */}
        {currentStep === 4 && (
          <label className="flex items-start gap-3 text-sm text-black/60">
            <input
              type="checkbox"
              checked={formData.declarationAccepted}
              onChange={e => setFormData({...formData, declarationAccepted: e.target.checked})}
            />
            I confirm that all information provided is accurate and I am applying for TACTOS Business Consultation with serious intent.
          </label>
        )}

        {/* NAVIGATION */}
        <div className="flex justify-between pt-4">
          {currentStep > 1 && (
            <button
              type="button"
              onClick={() => setCurrentStep(s => s - 1)}
              className="px-4 py-2 border rounded-lg"
            >
              Back
            </button>
          )}

          <button
            type="button"
            disabled={processing}
            onClick={() => {
              if (currentStep < 4) {
                setCurrentStep(s => s + 1)
              } else {
                handleSubmit()
              }
            }}
            className="ml-auto px-6 py-2 bg-[#fd3e3d] text-white rounded-lg"
          >
            {currentStep < 4 ? "Next" : <> {processing?"Loading":"Submit"}</>}
          </button>
        </div>

      </form>
    </div>
  </div>
)}


    </>
  );
};

export default BussinessPage;
